// Shared helpers for RecruitFlow candidate views

export const AGE_STYLES = {
  green: {
    dot: "bg-emerald-500",
    ring: "border-l-4 border-emerald-500",
    pill: "bg-emerald-50 text-emerald-700 border-emerald-500",
    label: "≤ 3 days",
  },
  yellow: {
    dot: "bg-amber-500",
    ring: "border-l-4 border-amber-500",
    pill: "bg-amber-50 text-amber-700 border-amber-500",
    label: "4–7 days",
  },
  red: {
    dot: "bg-[#FF2A2A]",
    ring: "border-l-4 border-[#FF2A2A]",
    pill: "bg-red-50 text-[#B91C1C] border-[#FF2A2A]",
    label: "8+ days",
  },
};

export function formatFee(n) {
  const value = Number(n || 0);
  if (!value) return "—";
  return `A$${value.toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
}

export function formatBytes(bytes) {
  if (!bytes) return "0 B";
  const units = ["B", "KB", "MB", "GB"];
  let i = 0;
  let n = bytes;
  while (n >= 1024 && i < units.length - 1) {
    n /= 1024;
    i++;
  }
  return `${n.toFixed(n >= 10 ? 0 : 1)} ${units[i]}`;
}
